import intersect from '@alpinejs/intersect';
import Alpine from 'alpinejs';
import calculatedRow from './components/calculatedRow';
import calculatorBlock from './components/calculatorBlock';
import healthCareCalculator from './components/healthCareCalculator';
import reveal from './components/reveal';

// Start the InstantSearch chunk download as soon as main.js runs, so it's in
// flight before the `load` event fires. Otherwise Alpine.start() serializes
// behind a 460 kB fetch and early test/user interactions race Alpine init.
const instantSearchFactoryPromise = document.querySelector('[x-data^="AlpineInstantSearch"]')
    ? import('./AlpineInstantSearchFactory').then((m) => m.default)
    : null;

window.addEventListener('load', async () => {
    if (instantSearchFactoryPromise) {
        const factory = await instantSearchFactoryPromise;
        window.AlpineInstantSearch = factory();
    }

    Alpine.plugin(intersect);

    Alpine.data('healthCareCalculator', healthCareCalculator);
    Alpine.data('calculatorBlock', calculatorBlock);
    Alpine.data('calculatedRow', calculatedRow);
    Alpine.data('reveal', reveal);

    window.Alpine = Alpine;

    Alpine.start();
});
